import { emptyCheckItemMedia, type CheckItem, type DatabaseFile, type Section } from '../types';

export const QUICK_GROCERY_PATH = 'database/grocery.md';
export const QUICK_TODO_PATH = 'database/todos.md';

export type QuickListKind = 'grocery' | 'todo';

export const QUICK_LIST_TARGETS: Record<
  QuickListKind,
  { path: string; sectionTitle: string; promptTitle: string; placeholder: string }
> = {
  grocery: {
    path: QUICK_GROCERY_PATH,
    sectionTitle: 'Groceries',
    promptTitle: 'Add grocery item',
    placeholder: 'e.g. Milk',
  },
  todo: {
    path: QUICK_TODO_PATH,
    sectionTitle: 'Quick To-Dos',
    promptTitle: 'Add quick to-do',
    placeholder: 'e.g. Fix garage smoke detector',
  },
};

export function todayIsoDate(): string {
  return new Date().toISOString().split('T')[0]!;
}

export function buildQuickChecklistItem(text: string, date = todayIsoDate()): CheckItem {
  return {
    raw: '',
    text: text.trim(),
    date,
    state: 'open',
    ...emptyCheckItemMedia(),
  };
}

export function findQuickListSection(file: DatabaseFile, kind: QuickListKind): Section | undefined {
  const title = QUICK_LIST_TARGETS[kind].sectionTitle;
  return file.sections.find(s => s.title === title);
}

/** Prepend a dated checklist row to the target section (newest at top). */
export function addQuickListItemToFile(
  file: DatabaseFile,
  kind: QuickListKind,
  text: string,
  date = todayIsoDate()
): CheckItem {
  const trimmed = text.trim();
  if (!trimmed) {
    throw new Error('Item text cannot be empty.');
  }
  const section = findQuickListSection(file, kind);
  if (!section) {
    throw new Error(`Section "${QUICK_LIST_TARGETS[kind].sectionTitle}" not found.`);
  }
  const item = buildQuickChecklistItem(trimmed, date);
  section.items.unshift(item);
  return item;
}
